// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"1088acbc6f88bab7","5285":"5d11f6b86da7b11a"}[chunkId] + ".css";
};